
































































import { Component, Prop, Vue } from 'vue-property-decorator'

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget
}

@Component
export default class HomeFormImageDrop extends Vue {
  /*************************
   *  Drag and Drop feature
   ************************/
  @Prop({ required: true }) private image!: string

  async onDrop(e: DragEvent) {
    e.stopPropagation()
    e.preventDefault()

    const files = e.dataTransfer!.files
    await this.createFile(files[0])
  }

  onChange(e: HTMLInputEvent): void {
    const files = e.target!.files
    this.createFile(files![0])
  }

  async createFile(file: File) {
    if (!file.type.match(/image.(jpg|jpeg|png)/i)) {
      this.$emit('invalid-image')
      return
    }
    const reader: FileReader = new FileReader()
    return new Promise((resolve) => {
      reader.onload = () => {
        this.$emit('image-change', reader.result!)
        resolve()
      }
      reader.readAsDataURL(file)
    })
  }

  removeFile(): void {
    this.$emit('image-change', '')
  }
  /******************************
   *  End: Drag and Drop feature
   *****************************/
}
